<template>

<div>
<iframe style="width: 100%; height: 100vh;" :src="src_url" frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  data(){
    return {
      src_url : ''
    }
  },
  methods:{
    isMobile() {
    const userAgent = navigator.userAgent.toLowerCase();
    
    return /mobile|android|iphone|ipad|phone/i.test(userAgent);
  }
  },
  created(){
   
    if(this.isMobile()){
      // h5
        this.src_url = 'https://b.bobiton.com/#/'
    }else {
   
       this.src_url = 'https://a.bobiton.com/'
    }
  }
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
</style>